import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { List, Modal } from 'antd';
import { NavLink } from 'react-router-dom';
import { useLocalization } from '../../../../../../../../util/useLocalization';
import {
  PersonEntityMergeActivityModalQuery,
  PersonEntityMergeActivityModalQueryVariables
} from '../../../../../../../../../gql/typings';
import { Locale } from '../../../../../../../../../localization/LocalizationKeys';

type AdminMergeItemPersonActivitiesModalProps = {
  open: boolean;
  close: () => void;
  activityIds: number[];
};

const AdminMergeItemPersonActivitiesModal: React.FC<AdminMergeItemPersonActivitiesModalProps> = ({
  open,
  close,
  activityIds,
}) => {
  const localization = useLocalization();
  const {
    data,
    loading,
  } = useQuery<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>(DATA_QUERY, {
    variables: { activityIds },
  });


  return (
    <Modal
      open={open}
      onCancel={close}
      footer={<></>}
    >
      {localization.pluralMessage(Locale.Text.Merge_request_activities_move_modal, activityIds.length)}
      <List
        loading={loading}
        dataSource={data?.activities.nodes ?? []}
        renderItem={activity => (
          <List.Item>
            <NavLink to={`/activity/${activity.id}`} target="_blank">
              {activity.heading}
            </NavLink>
          </List.Item>
        )}
      />
    </Modal>
  );
};

const DATA_QUERY = gql`
  query PersonEntityMergeActivityModal($activityIds: [ID!]!) {
    activities(criteria: { ids: $activityIds }) {
      hash
      nodes {
        id
        heading
      }
    }
  }
`;

export default AdminMergeItemPersonActivitiesModal;
